import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";
// Icons
import { Plus, ArrowLeft, SearchIcon, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import SeedFarmerColumn from "Common/Components/ColumnData/SeedFarmerColumn";
import SeedFormModal from "Common/Components/SeedFarmerModal/SeedFormModal";
const SeedFarmer = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  const [isEdit, setIsedit] = useState<boolean>(false);
  // Delete Modal

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataSeedList, setdataSeedList] = useState<any>([]);
  const [dataFactoryList, setdataFactoryList] = useState<any>([]);
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [seed_amount, setseed_amount] = useState<any>();
  const [price, setprice] = useState<any>();
  const [FactoryName, setFactoryName] = useState<any>();
  const [dataSeedID, setDataSeedID] = useState<any>();
  const [commitment_idList, setcommitment_idList] = useState<any>();
  const [coomitID, setcoomitID] = useState<any>();
  const [SearchValueCommit, setsetSearchValueCommit] = useState<any>();
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();

  const [dataFactoryID, setDataFactoryID] = useState<any>();
  const localstorageID = localStorage.getItem("crop_year_id");
  const [selectedCommitment, setSelectedCommitment] = useState<any>(null);
  const [seednameForEdit, setseednameForEdit] = useState<any>(null);
  const [seedIDDForEdit, setseedIDDForEdit] = useState<any>(null);
  const [idSeed, setidSeed] = useState<any>(null);
  const [isLoadingBtn, setisLoadingBtn] = useState<any>();
  const [defultcheckedPrice, setdefultcheckedPrice] = useState<any>(true);
  const [FarmerNameForEdit, setFarmerNameForEdit] = useState<any>("");
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const [seedSearchValue, setSeedSearchValue] = useState<any>("");
  const [isLoadingBtnModal, setisLoadingBtnModal] = useState<any>("");

  const [selectedFarmerInfo, setSelectedFarmerInfo] = useState<any>({
    amount_of_land: "",
    village_name: "",
    date_set: "",
  });
  const sortLabels: any = {
    farmer_name: "نام کشاورز",
    remaining_receivable_payable_balance: "مانده طلب / بدهی",
    price: "قیمت کشاورز",
    factory_name: "نام کارخانه",
    commitment_number: "شماره تعهد",
    seed_name: "اسم بذر",
    seed_amount: "مقدار بذر",
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isEdit && coomitID) {
        try {
          const response = await axios.get(
            `https://api.havirkesht.ir/farmers-seed/${coomitID}`
          );
          const data = response.data;
          if (data) {
            setSelectedCommitment({ value: data.id, label: data.farmer_name });
          }
        } catch (error) {
          console.error("خطا در دریافت اطلاعات:", error);
        }
      }
    };

    fetchData();
  }, [isEdit, coomitID]);

  useEffect(() => {
    const getFarmerInfo = async () => {
      try {
        setisLoadingBtnModal(true);
        const res = await axios.get(
          `https://api.havirkesht.ir/commitment/${Number(coomitID)}`, // توجه: coomitID به commitID تغییر کرد
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        if (res?.data.amount_of_land) {
          setisLoadingBtnModal(false);
          setSelectedFarmerInfo({
            amount_of_land: res?.data?.amount_of_land || "", // اگر null بود، خالی برگردان
            village_name: res?.data?.village_name || "",
            date_set: res?.data?.date_set || "",
          });
        }
      } catch (error) {
        setisLoadingBtnModal(false);
        console.error("Error fetching farmer info:", error);
      }
    };
    getFarmerInfo();
  }, [coomitID]);

  useEffect(() => {
    const fetchData = async () => {
      if (isEdit && dataSeedID) {
        try {
          const response = await axios.get(
            `https://api.havirkesht.ir/seed/${dataSeedID}`
          );
          const data = response.data;
          if (data) {
            setSelectedCommitment({ value: data.id, label: data.seed_name });
          }
        } catch (error) {
          console.error("خطا در دریافت اطلاعات:", error);
        }
      }
    };

    fetchData();
  }, [isEdit, dataSeedID]);

  useEffect(() => {
    const featchDatacropyear = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == localstorageID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    const fetchDataseed = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = "https://api.havirkesht.ir/seed/";
        if (seedSearchValue && seedSearchValue?.trim() !== "") {
          const searchParams = new URLSearchParams();
          searchParams.append("search", seedSearchValue.trim());
          url += `?${searchParams.toString()}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataSeedList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    const fetchDataFactory = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataFactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchDataFactory();
    fetchDataseed();
    featchDatacropyear();
  }, [seedSearchValue]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${localstorageID}`;
        if (SearchValueCommit && SearchValueCommit.trim() !== "") {
          url += `&search=${encodeURIComponent(SearchValueCommit.trim())}`;
        }

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setcommitment_idList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [SearchValueCommit]);

  const handlerUpdate = (ele: any) => {
    setIsedit(true);
    setShow(true);
    console.log(ele);
    setDataFactoryID(ele.factory_id);
    setFarmerNameForEdit(ele.farmer_name);
    setcoomitID(ele?.commitment_id);
    setseednameForEdit(ele?.seed_name);
    setseedIDDForEdit(ele?.seed_id);
    setFactoryName(ele?.factory_name);
    setidSeed(ele.id);
    setseed_amount(ele?.seed_amount);
    setprice(ele?.price);
    setdefultcheckedPrice(ele?.price > 0 ? false : true);
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(newPage, newSize);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const fetchData = async (page: number, size: number) => {
    setisLoadingBtn(true);
    try {
      const base = "https://api.havirkesht.ir/farmers-seed/";
      const params = new URLSearchParams();

      params.set("size", String(size));
      params.set("page", String(page));
      if (localstorageID != null)
        params.set("crop_year_id", String(localstorageID));

      // فقط یک سرچ: اولویت با searchValue.trim()، بعد searchValue
      const term =
        (typeof searchValue === "string" && searchValue.trim()) ||
        (typeof searchValue === "string" && searchValue.trim()) ||
        "";
      if (term) params.set("search", term);

      // سورت هماهنگ با step
      if (sortState) {
        if (sortState.step === 2) {
          params.set("sort_by", "created_at");
          params.set("sort_order", "desc");
        } else {
          // step 0 یا 1
          const by = sortState.name || "updated_at";
          const order = sortState.order === "asc" ? "asc" : "desc";
          params.set("sort_by", by);
          params.set("sort_order", order);
        }
      }

      const url = `${base}?${params.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });

          setData(response.data.items);
          
      setalldata(response?.data?.total);
      setTotalPages(response?.data?.pages);
    } catch (error) {
      console.error("خطا در دریافت پرداخت‌ها:", error);
      toast.error("خطا در بارگذاری پرداخت‌ها");
    } finally {
      setisLoadingBtn(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue, sortState]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/farmers-seed/${eventData}`
        );
        if (res.status === 200) {
          Swal.fire({
            title: "حذف بذر کشاورز",
            text: "عملیات حذف با موفقیت انجام شد",
            icon: "success",
          });
          setreload(!reload);
        } else {
          Swal.fire({
            title: "حذف بذر کشاورز",
            text: "مشکلی در حذف به وجود امده است",
            icon: "error",
          });
        }
        setDeleteModal(false);
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      seed_amount: isEdit ? seed_amount : "",
      priceinput: isEdit ? price : "",
    },
    validationSchema: Yup.object({
      seed_amount: Yup.number().required("لطفاً مقدار را وارد کنید"),
    }),
    onSubmit: async (values) => {
      setisLoadingBtn(true);
      if (values.seed_amount <= 0) {
        toast.error("مقدار نمی تواند صفر یا کمتر باشد");
        setisLoadingBtn(false);
        return setShow(true);
      }
      if (isEdit) {
        try {
          const update = {
            seed_amount: values.seed_amount,
            commitment_id: coomitID,
            factory_id: Number(dataFactoryID),
            seed_id: seedIDDForEdit,
            price: defultcheckedPrice ? null : Number(values.priceinput),
            price_for_all_farmers_checkbox: defultcheckedPrice,
            crop_year_id: Number(localStorage.getItem("crop_year_id")),
          };

          const res = await axios.put(
            `https://api.havirkesht.ir/farmers-seed/${Number(idSeed)}`,
            update
          );
          if (res.status === 200) {
            Swal.fire({
              title: "بروزرسانی بذر کشاورز",
              text: "بروز رسانی بذر کشاورز با موفقیت انجام شد",
              icon: "success",
            });
            setIsedit(false);
            resetForm();
          }
          resetForm();
        } catch (error: any) {
          setisLoadingBtn(false);
          if (error.status == 404) {
            setShow(true);
            return Swal.fire({
              title: "ثبت سم کشاورز",
              text: " قیمت بذر کارخانه برای کارخانه، بذر و سال زراعی مشخص شده یافت نشد لطفا قیمت را وارد کنید",
              icon: "warning",
            });
          }
          toast.error("خطا در بروزرسانی اطلاعات");
          setisLoadingBtn(false);
        }
      } else {
        if (!dataSeedID || !coomitID || !dataFactoryID) {
          setShow(true);
          setisLoadingBtn(false);
          return toast.error(
            "لطفا بذر و  نام کشاورز   و  کارخانه را انتخاب کنید"
          );
        }
        const newData = {
          seed_amount: values.seed_amount,
          commitment_id: coomitID,
          seed_id: dataSeedID,
          price: defultcheckedPrice ? 0 : Number(values.priceinput),
          price_for_all_farmers_checkbox: defultcheckedPrice,
          factory_id: dataFactoryID,
          crop_year_id: localStorage.getItem("crop_year_id"),
        };

        try {
          const res = await axios.post(
            "https://api.havirkesht.ir/farmers-seed/",
            newData
          );
          const FarmerID = Number(res?.data?.id);
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-seed-notification/${FarmerID}`
          );

          if (res.status === 201) {
            Swal.fire({
              title: "ثبت بذر کشاورز",
              text: "ثبت بذر کشاورز با موفقیت انجام شد",
              icon: "success",
            });
            setreload(!reload);
            resetForm();
          }
          resetForm();
        } catch (error: any) {
          setisLoadingBtn(false);
          if (error.status == 404) {
            setShow(true);
            return await Swal.fire({
              title: "ثبت سم کشاورز",
              text: " قیمت بذر کارخانه برای کارخانه، بذر و سال زراعی مشخص شده یافت نشد لطفا قیمت را وارد کنید",
              icon: "warning",
            });
          }
          console.log(error);
          toast.error("خطا در ثبت اطلاعات");
          setisLoadingBtn(false);
        }
      }
      toggle();
    },
  });
  function resetForm() {
    setIsedit(false);
    setreload(!reload); // این خط باعث fetch مجدد داده‌ها می‌شود
    setShow(false);
    setisLoadingBtn(false);
    setSelectedCommitment(null);
    setcoomitID(null);
    setDataSeedID(null);
    setDataFactoryID(null);
    setdefultcheckedPrice(true);
    setseednameForEdit(null);
    setidSeed(null);
    validation.resetForm();
  }

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setcoomitID(null);
      setSelectedCommitment(null);
      setIsedit(false);
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const formatNumber = (num: number | string) => {
    if (!num) return "";
    const numStr = num.toString().replace(/,/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum.replace(/,/g, "");
  };

  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = SeedFarmerColumn({
    onClickDelete,
    handlerUpdate,
    columnName,
  });
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت بذرکشاورز" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="flex w-96"></div>
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center flex-col md:flex-row gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع بذر کشاورزان (
              <b className="total-Employs">{alldata?.toString()}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                    {searchValue ? (
                      <X
                        size={15}
                        className="cursor-pointer"
                        onClick={() => setsearchValue("")}
                      />
                    ) : (
                      <SearchIcon size={15} />
                    )}
                  </span>
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <Link
                to=""
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl"> ثبت بذر کشاورز </span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
              <Link
                to="/placed-farmer"
                type="button"
                className="text-white btn mr-2 bg-green-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">بازگشت </span>{" "}
                <ArrowLeft className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${
                    sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                  }`}
            </div>
          )}

          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={12}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <SeedFormModal
        show={show}
        isEdit={isEdit}
        onHide={toggle}
        onSubmit={handleClick}
        validation={validation}
        selectedCommitment={selectedCommitment}
        setSelectedCommitment={setSelectedCommitment}
        setcoomitID={setcoomitID}
        coomitID={coomitID}
        setSeedSearchValue={setSeedSearchValue}
        setsetSearchValueCommit={setsetSearchValueCommit}
        commitment_idList={commitment_idList}
        FarmerNameForEdit={FarmerNameForEdit}
        isLoadingBtnModal={isLoadingBtnModal}
        selectedFarmerInfo={selectedFarmerInfo}
        dataSeedID={dataSeedID}
        setDataSeedID={setDataSeedID}
        dataSeedList={dataSeedList}
        seednameForEdit={seednameForEdit}
        dataFactoryID={dataFactoryID}
        setDataFactoryID={setDataFactoryID}
        dataFactoryList={dataFactoryList}
        FactoryName={FactoryName}
        defultcheckedPrice={defultcheckedPrice}
        setdefultcheckedPrice={setdefultcheckedPrice}
        YearCoptSelect={YearCoptSelect}
        isLoadingBtn={isLoadingBtn}
        formatNumber={formatNumber}
        parseFormattedNumber={parseFormattedNumber}
      />
    </React.Fragment>
  );
};

export default SeedFarmer;
